import React, { ReactElement } from 'react';
import { Result } from 'antd';
import { Link } from 'react-router-dom';
import usePermissions from 'src/hooks/usePermissions';
import { PermissionsInterface } from 'src/store/sessionSlice';

interface Props {
  capability: keyof PermissionsInterface;
  children: ReactElement;
}

// Route-level gate: renders a 403 page when the capability is missing.
const RequireCapability = ({ capability, children }: Props) => {
  const permissions = usePermissions();

  if (!permissions[capability]) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={<Link to='/'>Back Home</Link>}
      />
    );
  }

  return children;
};

export default RequireCapability;
